import queryString from "query-string";
import {
  setStoreItemsCopy,
  updateStoreItemCopy,
  removeStoreItemCopy,
  addStoreCopy,
} from "./appifyActions";
import { privateFetch, privateFetchWithToken } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";
import { privateFetchNoBody } from "../../apis";

// StoreItem Action Dispatchers
export const setStoreItems = (storeItems) => ({
  type: "SET_STORE_ITEMS",
  storeItems,
});

export const removeStoreItems = () => ({
  type: "REMOVE_STORE_ITEMS",
});

export const removeStoreItem = (storeItem) => ({
  type: "REMOVE_STORE_ITEM",
  storeItem,
});

export const updateStoreItem = (storeItem) => ({
  type: "UPDATE_STORE_ITEM",
  storeItem,
});

export const addTempStoreItem = () => ({
  type: "ADD_TEMP_STORE_ITEM",
});

export const deleteTempStoreItem = (storeItem) => ({
  type: "DELETE_TEMP_STORE_ITEM",
  storeItem,
});
export const addTempStoreCloneItem = (storeItem) => ({
  type: "ADD_TEMP_STORE_CLONE_ITEM",
  storeItem,
});

export const updateTempStoreItem = (storeItem) => ({
  type: "UPDATE_TEMP_STORE_ITEM",
  storeItem,
});

// GET all storeItems associated with an appId
export const getStoreItems = (appId, templateId, accessToken) => (dispatch) => {
  // console.log("getting store items for appId: " + appId);
  // console.log("getting store items for templateId: " + templateId);
  const url =
    __BASE_API_URL__ +
    `/purchaseItems?appId=${appId}&templateId=${templateId}&includeOffline=true&includeRetired=true`;
  //purchaseItems?appId=4405&templateId=48013&includeOffline=true

  if (accessToken) {
    return privateFetchWithToken(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: accessToken,
      }),
    }).then((storeItems) => {
      dispatch(setStoreItems(storeItems));
      dispatch(setStoreItemsCopy(storeItems));
      return storeItems;
    });
  }

  return privateFetch(url, {
    method: "GET",
  }).then((storeItems) => {
    dispatch(setStoreItems(storeItems));
    dispatch(setStoreItemsCopy(storeItems));
    return storeItems;
  });
};

export const getStoreItemById = (itemId) => {
  const url = __BASE_API_URL__ + ` /purchaseItem/${itemId}`;
  return privateFetch(url, {
    method: "GET",
  }).then((storeItems) => {
    dispatch(setStoreItems(storeItems));
    dispatch(setStoreItemsCopy(storeItems));
    return storeItems;
  });
};

export const createCategoryGroup = (itemId, categoryObject) => {
  const url =
    __BASE_API_URL__ + `/purchaseItem/${itemId}/additionalOptionsGroup`;
  const body = categoryObject;
  return privateFetch(url, {
    method: "POST",
    body: JSON.stringify(body),
  }).then((storeItem) => {
    // dispatch(setStoreItems(storeItems));
    // dispatch(setStoreItemsCopy(storeItems));
    return storeItem;
  });
};

// Save a storeItem
export const createStoreItem =
  (storeItem, isClone, accessToken) => async (dispatch) => {
    // console.log("printing storeItem before create:");
    // console.dir(storeItem);
    if (storeItem.id != "newStoreItem") {
      // console.log("setting clone as new store item");
      storeItem.id = "newStoreItem";
    }
    const newStoreItem = await postStoreItem(storeItem, accessToken);
    // console.log("got new store item: ");
    // console.dir(newStoreItem);
    if (!isClone) {
      dispatch(updateTempStoreItem(newStoreItem));
      dispatch(addStoreCopy(newStoreItem));
    } else {
      dispatch(deleteTempStoreItem(newStoreItem));
    }

    return newStoreItem;
  };

const timestampConvertion = (time) => {
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }
  const datetime = new Date(time);
  return (
    datetime.getUTCFullYear() +
    "-" +
    pad(datetime.getUTCMonth() + 1) +
    "-" +
    pad(datetime.getUTCDate()) +
    "T" +
    pad(datetime.getUTCHours()) +
    ":" +
    pad(datetime.getUTCMinutes()) +
    ":" +
    pad(datetime.getUTCSeconds())
  );
};

const updateTimeParams = (params) => {
  const newParams = {
    ...params,
  };
  if (newParams.expiration) {
    newParams.expiration = timestampConvertion(params.expiration);
    // console.log(newParams.expiration);
  }
  if (newParams.usePurchasedItemsBy) {
    newParams.usePurchasedItemsBy = timestampConvertion(
      params.usePurchasedItemsBy
    );
  }

  return newParams;
};

// POST a StoreItem to the database
const postStoreItem = (storeItem, accessToken) => {
  // console.log("printing og storeItem before create:");
  // console.dir(storeItem);

  const params = updateTimeParams(storeItem);
  // console.dir(JSON.stringify(params));

  const url = __BASE_API_URL__ + `/application/${storeItem.appId}/purchaseItem`;

  if (accessToken) {
    return privateFetchWithToken(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: accessToken,
      }),
      body: JSON.stringify(params),
    }).then((storeItem) => {
      if (storeItem) {
        return storeItem;
      } else {
        console.log("ERROR");
      }
    });
  }

  return privateFetch(url, {
    method: "POST",
    body: JSON.stringify(params),
  }).then((storeItem) => {
    if (storeItem) {
      return storeItem;
    } else {
      console.log("ERROR");
    }
  });
};

// UPDATE a StoreItem
export const putStoreItem = (storeItem, accessToken) => (dispatch) => {
  if (storeItem.maxPurchasesTotal === null) {
    storeItem.maxPurchasesTotal = -1;
  }
  if (storeItem.maxPurchasesPerUser === null) {
    storeItem.maxPurchasesPerUser = -1;
  }
  if (storeItem.imageUrl === null) {
    storeItem.imageUrl = "";
  }
  if (storeItem.importantNote === null) {
    storeItem.importantNote = "";
  }
  if (storeItem.finePrint === null) {
    storeItem.finePrint = "";
  }
  // console.log("updating store item with expiration");
  // console.log(storeItem.expiration);
  // if (storeItem.expiration === null) {
  //   storeItem.expiration = -1;
  // }
  // console.log(storeItem);
  const params = updateTimeParams(storeItem);
  // console.log(params);
  const queryParams = queryString.stringify(params);
  // console.log(queryParams);

  const url = __BASE_API_URL__ + `/v2/purchaseItem/${params.id}?${queryParams}`;

  if (accessToken) {
    return privateFetchWithToken(url, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: accessToken,
      }),
    }).then((storeItem) => {
      dispatch(updateStoreItem(storeItem));
      dispatch(updateStoreItemCopy(storeItem));
      // console.log(storeItem);
      return storeItem;
    });
  }

  return privateFetch(url, {
    method: "PUT",
  }).then((storeItem) => {
    dispatch(updateStoreItem(storeItem));
    dispatch(updateStoreItemCopy(storeItem));
    // console.log(storeItem);
    return storeItem;
  });
};

export const updateSelectionItemRanks =
  (itemObject, groupId, accessToken) => (dispatch) => {
    const url =
      __BASE_API_URL__ +
      `/additionalOptionsGroup/${groupId}/additionalOptionsItems/sortOrder`;

    const body = { additionalOptionItemsRanking: itemObject };
    if (accessToken) {
      return privateFetchWithToken(url, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(body),
      }).then((items) => {
        return items;
      });
    }
    return privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(body),
    }).then((items) => {
      // console.log("success! updating selection item ranks...");
      // console.dir(items);
      return items;
    });
  };

export const updateGroupRanks = (groupObject, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/additionalOptionsGroups/sortOrder`;

  const body = { additionalOptionGroupsRanking: groupObject };

  if (accessToken) {
    return privateFetchWithToken(url, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: accessToken,
      }),
      body: JSON.stringify(body),
    }).then((group) => {
      // console.log("success! updating group ranks...");
      // console.dir(group);
      return group;
    });
  }
  return privateFetch(url, {
    method: "PUT",
    body: JSON.stringify(body),
  }).then((group) => {
    // console.log("success! updating group ranks...");
    // console.dir(group);
    return group;
  });
};

// UPDATE StoreItem Ranks
export const updateStoreItemRanks =
  (storeObject, accessToken) => (dispatch) => {
    const url = __BASE_API_URL__ + `/purchaseItemsRank`;
    // console.log("MAKING API CALL with Object:");
    const body = { purchaseItemRanking: storeObject };
    // console.log(body);

    if (accessToken) {
      return privateFetchWithToken(url, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(body),
      }).then((storeItems) => {
        // console.log(storeItems);
        dispatch(setStoreItems(storeItems));
        dispatch(setStoreItemsCopy(storeItems));
        return storeItems;
      });
    }

    return privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(body),
    }).then((storeItems) => {
      // console.log(storeItems);
      dispatch(setStoreItems(storeItems));
      dispatch(setStoreItemsCopy(storeItems));
      return storeItems;
    });
  };

// DELETE a StoreItem in database
export const deleteStoreItem = (storeItem, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/purchaseItem/${storeItem.id}`;

  if (accessToken) {
    return privateFetchWithToken(url, {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: accessToken,
      }),
    }).then((res) => {
      if (res) {
        const newStoreItem = Object.assign({}, storeItem);
        newStoreItem.retired = 1;
        dispatch(updateStoreItem(newStoreItem));
        dispatch(updateStoreItemCopy(newStoreItem));
      }
    });
  }

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      const newStoreItem = Object.assign({}, storeItem);
      newStoreItem.retired = 1;
      dispatch(updateStoreItem(newStoreItem));
      dispatch(updateStoreItemCopy(newStoreItem));
    }
  });
};
